//import store from '../store';

export default (Vue, router, Axios) => {
  if (!router) {
    // console.error('You have pass router as arg');
    return;
  }

  if (!Axios) {
    //console.error('You have to install axios');
    return;
  }

  let nodeUrl
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    nodeUrl = 'http://127.0.0.1:3000';
  } else {
    nodeUrl = 'https://premiumdevelopment.tech/api/';
    // nodeUrl = 'https://test.enhakiel.ovh/api/';
  }

  const axios = Axios.create({
    baseURL: nodeUrl,

    headers: {
      // Authorization: `Bearer ${store.state.token}`
      // Authorization: 'Bearer',
    }
  })

  if (!axios.CancelToken) {
    axios.CancelToken = Axios.CancelToken;
  }
  if (!axios.isCancel) {
    axios.isCancel = Axios.isCancel;
  }

  // if (axios.headers !== undefined) {
  //   console.log(
  //     'axiosInstance.headers.Authorization: ',
  //     axios.headers.Authorization
  //   )
  // }

  //     axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.token;
  // originalRequest.headers.Authorization = `Bearer ${result.data.token}`;

  /**
   * Affectation des props
   */
  Vue.axios = axios;

  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axios
      }
    },

    $http: {
      get() {
        return axios
      }
    }
  });
}
